module.exports = __webpack_public_path__ + "static/media/spot21.587b16a8.webp";